import { render, staticRenderFns } from "./ResourcesLatest.vue?vue&type=template&id=435a3593&scoped=true"
import script from "./ResourcesLatest.vue?vue&type=script&lang=js"
export * from "./ResourcesLatest.vue?vue&type=script&lang=js"
import style0 from "./ResourcesLatest.vue?vue&type=style&index=0&id=435a3593&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435a3593",
  null
  
)

export default component.exports